const mealVideoPopUpTranslations = {
  cancel: "Cancel",
};

export default mealVideoPopUpTranslations;
